import { HelpCenterCategory } from '../models/helpCenterCategory';

export type HelpCenterSection = {
  mainCategory: HelpCenterCategory;
  cards: HelpCenterCategory[];
};

/**
 * Huvudkategorierna som rubriker med sina underkategorier som kort, i API:ts ordning. En huvudkategori med egna
 * artiklar blir första kortet under sin rubrik. En rubrik utan kort tas inte med.
 */
export const groupHelpCenterCategories = (categories: HelpCenterCategory[]): HelpCenterSection[] =>
  categories
    .filter((category) => category.parentId === null)
    .map((mainCategory) => ({
      mainCategory,
      cards: [...(mainCategory.articleCount > 0 ? [mainCategory] : []), ...categories.filter((category) => category.parentId === mainCategory.id)],
    }))
    .filter((section) => section.cards.length > 0);
